import React, { useState, useEffect } from "react";
import WidgetGrid from "../WidgetGrid";
import ContentLoading from "components/ContentLoading";
import * as WidgetUtils from "../logic/WidgetUtils";

// Externals
import cn from "classnames";

// DevExtreme components
import Button from 'devextreme-react/button';

// Component styles
import classes from "./TabWidget.module.scss";

export function TabWidget(props) {
  const { ui, config, createChildWidget, doAction, data } = props;
  const [isLoading, setIsLoading] = useState(false);

  let widgetId = ui.id;
  let content = data && data.content ? parseInt(data.content) : 0;

  useEffect(() => {
    console.log("TabWidget data of " + ui.id + ": ", data);
  }, [data]);

  const onTabButtonClicked = async (event, actionId) => {
    setIsLoading(true);
    doAction(actionId).then(() => {
      setIsLoading(false);
    });
  };

  const renderTabButton = (tab, isActive) => {
    return (
      <Button
        className={isActive ? cn(classes.tabButton, "dx-theme-accent-as-border-color") : cn(classes.tabButton, classes.transparentBorderColor)}
        key={tab.ActionId}
        text={WidgetUtils.toCleanText(tab.HeaderText)}
        stylingMode="text"
        focusStateEnabled={false}
        activeStateEnabled={false}
        onClick={e => onTabButtonClicked(e, tab.ActionId)}
        height="100%"
      />
    );
  }

  const renderHeader = () => {
    let tabs = config.TabSelections;
    return (
      <div className={classes.header} style={{ height: config.TabSelectionHeight + "em" }}>
        {tabs.map((tab, index) => (
          renderTabButton(tab, (index === content))
        ))}
      </div>
    );
  };

  const gridWrapperStyle = (showTabs) => {
    return {
      height: showTabs ? "calc(100% - " + config.TabSelectionHeight + "em)" : "100%"
    }
  };

  const renderGrid = (tabsShown) => {
    let grid = config.CurrentGrid;
    let rows = grid ? grid.Rows : [];
    let columns = grid ? grid.Columns : [];
    let widgetLocations = grid ? grid.WidgetLocations : [];
    return (
      <div style={gridWrapperStyle(tabsShown)}>
        <WidgetGrid rows={rows} columns={columns} widgetLocations={widgetLocations} containingWidgets={ui.containingWidgets} createChildWidget={createChildWidget} />
      </div>
    );
  };

  return config ? (
    <div className={classes.tabWrapper} id={widgetId}>
      {config.ShowTabSelections ? renderHeader() : <React.Fragment />}
      {isLoading ? <ContentLoading /> : renderGrid(config.ShowTabSelections)}
    </div>
  ) : null;
}
